import { action, observable, computed } from 'mobx'
import BaseStore from '@common/Table/store'
import Api from '@api/xi_feng/jiamengGoods.js'
class Store extends BaseStore {
  $listApi = Api.getFranchiseList
  $pageSize = 1000

  @observable totalCount = 0

  @observable keyword = ''

  @computed
  get listLen() {
    return this.$list.length
  }

  $extraOp = data => {
    this.totalCount = data.total_count
  }

  $getParams = () => {
    return {
      ...this.$params,
      keyword: this.keyword
    }
  }

  @action
  setStoreData = (type, value) => {
    this[type] = value
  }

  @action
  removeFranchise = async id => {
    let { success } = await Api.removeFranchise({ id })
    if (success) {
      this.$getList()
    }
  }

  @action
  orderFn = async (id, index, direction) => {
    let position = index
    if (direction == 'up') {
      if (index == 0) {
        return
      }
      position -= 1
    } else if (direction == 'down') {
      if (index === this.$list.length) {
        return
      }
      position += 1
    } else {
      position = 0
    }
    let { success } = await Api.superviseOrder({ id, position })
    if (success) {
      this.$getList()
    }
  }

  @action
  search = () => {
    this.$getList()
  }

  @action
  reset = () => {
    this.totalCount = 0
    this.keyword = ''
  }
}

export default Store
